import type { JSX } from 'react';

type SpinnerProps = {
  label?: string;
};

export function Spinner({ label = 'Chargement…' }: SpinnerProps): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full min-h-[8rem] w-full items-center justify-center"
    >
      <span
        aria-hidden="true"
        className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
